import { Component, OnInit, NgZone } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'
import * as CryptoJS from 'crypto-js'
import { Ng2DeviceService } from 'ng2-device-detector'
import { environment } from './../environments/environment'
import { DataService } from './data.service'
import { NavigationService } from './navigation/navigation.service'
import { AppService } from './app.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  currentUrl: any
  toggleStatus: boolean
  changeProfileServiceData: any
  deviceInfo: any
  loginUser: any = {}
  contentInfo: any = {}
  favIcon = ''
  favImgPath = ''
  appConstant = environment
  constructor(
    private router: Router,
    private deviceService: Ng2DeviceService,
    private navigationService: NavigationService,
    private dataService: DataService,
    private route: ActivatedRoute,
    private zone: NgZone,
    private appService: AppService
  ) {

  }

  receiveMessage($event: boolean): any {
    this.toggleStatus = $event
  }

  ngOnInit(): any {
    if (window.location.href === this.appConstant.brandAdminBaseUrl) {
      this.router.navigate(['/brand-login'])
    } else if (window.location.href === this.appConstant.baseUrl) {
      this.router.navigate(['/'])
    }
    this.appService.getInformation().subscribe((data: any) => {
      this.contentInfo = JSON.stringify(data)
      this.favIcon = data.website_content.favicon_icon.favicon_icon
      localStorage.setItem('contentInfo', this.contentInfo)
      this.dataService.changeLocalData('update data')
      //Update fav icon dynamic
      if (this.favIcon) {
        this.favImgPath = environment.contentImagePath + this.favIcon
      } else {
        this.favImgPath = 'favicon.ico'
      }
      const favIcon: HTMLLinkElement = document.querySelector('#favicon')
      favIcon.href = this.favImgPath
    })
    window.addEventListener('storage', (event) => {
      //logout case all tab close
      if (event.storageArea == localStorage) {
        let token = localStorage.getItem('adminInfo')
        if (token == undefined || token == null) {
          this.router.navigate(['/'])
        }
      }
    })

    if (localStorage.getItem('adminInfo')) {
      const user: any = JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem('adminInfo'),
          environment.secretKey
        ).toString(CryptoJS.enc.Utf8)
      )
      this.loginUser = user
    }

    this.deviceInfo = this.deviceService.getDeviceInfo()
    localStorage.setItem('device_type', this.deviceInfo.device)
    this.navigationService.getContent().subscribe(
      (data: any) => {
        const setBaseData: any = CryptoJS.AES.encrypt(
          JSON.stringify(data),
          environment.secretKey
        ).toString()
        localStorage.setItem('baseData', setBaseData)
      },
      (err: any) => { }
    )
  }

  ngAfterViewInit() {
    window.addEventListener('storage', (e) => {
      if (e.key == 'adminInfo' && localStorage.getItem('adminInfo')) {
        // this.dataService.updateProfileService({ url: 'change' })
        const user: any = JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem('adminInfo'),
            environment.secretKey
          ).toString(CryptoJS.enc.Utf8)
        )
        if (this.loginUser.email !== user.email) {
          {
            this.router.routeReuseStrategy.shouldReuseRoute = function () {
              return false
            }
            let currentUrl = this.router.url
            this.router.navigateByUrl(currentUrl).then(() => {
              this.router.navigated = false
              this.router.navigate([this.router.url])
            })

            this.zone.run(() => {
              location.reload()
            })
          }
        }
      } else {
        if (localStorage.getItem('adminInfo')) {
          const user: any = JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem('adminInfo'),
              environment.secretKey
            ).toString(CryptoJS.enc.Utf8)
          )
          this.loginUser = user
        }
      }
    })
  }
}
